// Update labels for file fields on change

const handleCustomFileFields = () => {
    const fileFields = document.getElementsByClassName('custom-file-input');

    for (let i = 0; i < fileFields.length; i++) {
        const fileField = fileFields[i];
        const fileFieldLabel = document.getElementById(`label_${fileField.id}`);
        const originalLabel = fileFieldLabel.innerHTML;

        fileField.addEventListener('change', () => {
            fileFieldLabel.innerHTML = fileField.value ? fileField.value : originalLabel;
        });
    }
};

export default handleCustomFileFields;



// WEBPACK FOOTER //
// ./src/utils/handleCustomFileFields.js